import React from 'react'
import styled from "styled-components";
import useWindowSize from "./../hooks/useWindowSize";

function DrawerContentWrapper(props) {
  const screenStatus = useWindowSize();
  const drawerHeightBasedOnDrawerType = (props.drawerType === 'landscape' || props.drawerType === 'landscapeside') ?  {height: '289px'} : null

  //for Gradient overlay
  //    box-shadow: inset -15px 0px 16px 3px #fff;
  let diveStyle = `
  &::after {
    content: '';
    width: 35px;
    height:100%;
    top:10px;
    right: 0;
    position: absolute;
    box-shadow: inset -20px -3px 17px -3px #fff
  }`;
  const Layout = styled.div`
    ${screenStatus === "mobile" || screenStatus === "tablet" ? diveStyle : null}
  `;
    return (
        <Layout className={props.elClass} style={drawerHeightBasedOnDrawerType}>
            {props.children}
        </Layout>
    )
}

export default DrawerContentWrapper
